export default __webpack_public_path__ + "static/media/default-img.9b87935a.jpg";